import React, {useState /*, useContext */ } from 'react';
import { Button, Modal, Form, Input, message } from 'antd';
import * as Setting from '../utils/AuthUtils';
import { api } from '../AppConfig';
import { useTranslation } from 'react-i18next';

function UpdateLeague(props) {
    const [form] = Form.useForm();
    const [isActive,setIsActive] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const { t } = useTranslation();

    // console.warn('props di updateLeague:', props);

    function toggleModal() {
        if (isActive) {
            setIsActive(false);
        } else {
            setIsActive(true);
        }
    }

    function handleCancel() {
        setIsActive(false);
        form.resetFields();
    }

    function onFinish(values) {
        form.validateFields({ validateOnly: true })
        .then(async () => {
            const league = props.league;
            league.leagueName = values.name;
            league.referrerName = values.referrerName;
            league.facebookUrl = values.facebookUrl;


            const response = await fetch(api.leagues().update().href, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Setting.getToken(),
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(league) // body data type must match "Content-Type" header
            })
            .then((data) => data.json())

            if (response.errorMsg === "") {
                window.location.reload(false);
            } else {
                messageApi.error("You do not have the permission to edit this league! Check the inserted infos.");
            }
        })
        .catch((errorInfo) => {
            // console.warn('errorInfo:', errorInfo);
            messageApi.error("Please compile all required fields of the form!");
        })
    }

    return(
            <div>
                {contextHolder}
                <Modal title={t('leagues.update')} open={isActive} trigger="click" onOk={form.submit} onCancel={handleCancel} maskClosable={false} cancelText="Cancel" okText="Update">
                    <Form form={form} onFinish={onFinish} labelCol={{ span: 8, }} wrapperCol={{ span: 16, }} initialValues={{ "name": props.league.leagueName, "referrerName": props.league.referrerName, "facebookUrl": props.league.facebookUrl }}>
                    <Form.Item label="League Name" name="name" >
                        <Input disabled={!(props.rights ? props.rights.isAdmin || props.rights.isReferral : false)} placeholder="League Name" />
                    </Form.Item>
                    <Form.Item label="Referrer Name" name="referrerName" >
                        <Input disabled={!(props.rights ? props.rights.isAdmin || props.rights.isReferral : false)} placeholder="Referrer Name" />
                    </Form.Item>
                    <Form.Item label="Link Social" name="facebookUrl" >
                        <Input disabled={!(props.rights ? props.rights.isAdmin || props.rights.isReferral : false)} placeholder="Link Social" />
                    </Form.Item>
                    {/*
                    <Form.Item label="Participants" name="participants" rules={[{ required: true, message: 'Please insert a value!' },({ getFieldValue }) => ({
                        validator(_, value) {
                            if (!value || value > 0) {
                            return Promise.resolve();
                        }
                        return Promise.reject(new Error('Please insert a value greater than 0!'));
                        },
                    })]}>
                        <InputNumber min={8} max={800} placeholder="no. of participants" />
                    </Form.Item>
                    */}
                </Form>
                </Modal>
                <Button style={{ marginTop: 16 }} type="primary" onClick={toggleModal}>
                    {t('leagues.update')}
                </Button>
            </div>
    )
}

export default UpdateLeague;